module.exports = __webpack_public_path__ + "img/special_wild.6d8d9d50.png";